import { render, staticRenderFns } from "./Chemicals.vue?vue&type=template&id=106d94d9&scoped=true&"
import script from "./Chemicals.vue?vue&type=script&lang=js&"
export * from "./Chemicals.vue?vue&type=script&lang=js&"
import style0 from "./Chemicals.vue?vue&type=style&index=0&id=106d94d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106d94d9",
  null
  
)

export default component.exports